import type { SVGProps } from 'react'
const SvgLock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      stroke="#0F141E"
      strokeMiterlimit={10}
      strokeWidth={2.7}
      d="M9.5 9.625v-1.43c0-1.112.474-2.18 1.318-2.966A4.67 4.67 0 0 1 14 4c1.193 0 2.338.442 3.182 1.229S18.5 7.083 18.5 8.196v1.429"
    />
    <rect width={18} height={13.5} x={5} y={9.625} fill="#0F141E" rx={3} />
  </svg>
)
export default SvgLock
